<div class="container" [@oppage]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>